<template>
  <v-row wrap align-end>
    <v-flex px-1 py-1 shrink>
      <SelectableRideTypeInput
        @input="changeRideType"
        :rideType="bookingForm.booking.ride_type"
        :rideTypes="bookingForm.rideTypes"
        label="Ride Type"
        :error="bookingForm.errors.ride_type"
      />
    </v-flex>
    <v-flex px-1 py-1 shrink>
      <SimpleNumberInput
        @input="changePassengerCount"
        v-model="bookingForm.booking.num_people"
        prependIcon="people"
        label="PAX"
        :error="bookingForm.errors.num_people"
      />
    </v-flex>
    <v-flex px-1 py-1 shrink>
      <SimpleNumberInput
        @input="changeLuggageCount"
        v-model="bookingForm.booking.luggage"
        prependIcon="card_travel"
        label="LUG"
        :error="bookingForm.errors.luggage"
      />
    </v-flex>
    <v-flex shrink py-1 px-1>
      <SimpleTextInput
        @input="changeRoomTable"
        v-model="bookingForm.booking.room_number"
        label="Rm/Tbl"
        width="64px"
      />
    </v-flex>
    <v-flex px-1 shrink>
      <IconToggle @input="changePPE" v-model="bookingForm.booking.require_ppe" icon="coronavirus"></IconToggle>
    </v-flex>
    <v-flex px-1 shrink>
      <IconToggle
        @input="changeDisabled"
        v-model="bookingForm.booking.needs_disabled_access"
        icon="accessible"
      ></IconToggle>
    </v-flex>
    <v-flex px-1 shrink>
      <IconToggle
        @input="changePremium"
        v-model="bookingForm.booking.premium"
        hide-details
        icon="stars"
      >
        <v-icon color="grey" class="compact-form" slot="append">stars</v-icon>
      </IconToggle>
    </v-flex>
    <v-flex px-1 shrink>
      <IconToggle
        @input="changePets"
        v-model="bookingForm.booking.needs_pets"
        hide-details
        lg2
        icon="pets"
      >
        <v-icon color="grey" class="compact-form" slot="append">pets</v-icon>
      </IconToggle>
    </v-flex>
    <v-flex px-1 py-1 shrink>
      <SelectableBodyStyleInput
        @input="changeBodyType"
        :taxiType="bookingForm.booking.taxi_type"
        label="Taxi Type"
        :error="bookingForm.errors.taxi_type"
      />
    </v-flex>
    <v-flex px-1 py-1 shrink>
      <SimpleTextInput
        @input="changeFlightNumber"
        v-model="bookingForm.booking.flight_number"
        label="Flight"
        width="64px"
      />
    </v-flex>
    <v-flex px-1 shrink>
      <IconToggle
        @input="changeMeetAndGreet"
        v-model="bookingForm.booking.meet_and_greet"
        hide-details
        icon="all_inclusive"
      />
    </v-flex>
  </v-row>
</template>

<script>
import IconToggle from "@/components/widget/input/IconToggle.vue";
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import SimpleNumberInput from "@/components/widget/input/SimpleNumberInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import SelectableRideTypeInput from "@/components/widget/input/SelectableRideTypeInput.vue";
import SelectableBodyStyleInput from "@/components/widget/input/SelectableBodyStyleInput.vue";

export default {
  name: "VehicleRequirementsInput",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    IconToggle,
    BookingDateInput,
    SimpleTextInput,
    SelectableInput,
    SimpleNumberInput,
    SelectableRideTypeInput,
    SelectableBodyStyleInput
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    changeRoomTable(room_number) {
      this.bookingForm.booking.room_number = room_number;
      this.bookingForm.getBestDriver();
    },
    changeRideType(rideType) {
      this.bookingForm.changeRideType(rideType);
    },
    changeBodyType(bodyType) {
      this.bookingForm.booking.taxi_type = bodyType;
      this.bookingForm.getBestDriver();
    },
    changePassengerCount(num_people) {
      this.bookingForm.booking.num_people = parseInt(num_people);
      this.bookingForm.getBestDriver();
    },
    changeLuggageCount(luggage) {
      this.bookingForm.booking.luggage = parseInt(luggage);
    },
    changePPE(ppe) {
      this.bookingForm.booking.require_ppe = ppe;
      this.bookingForm.getBestDriver();
    },
    changeDisabled(disabled) {
      this.bookingForm.booking.needs_disabled_access = disabled;
      this.bookingForm.getBestDriver();
    },
    changePets(needs_pets) {
      this.bookingForm.booking.needs_pets = needs_pets;
      this.bookingForm.getBestDriver();
    },
    changePremium(premium) {
      this.bookingForm.booking.premium = premium;
      this.bookingForm.getBestDriver();
    },
    changeFlightNumber(flight_number) {
      this.bookingForm.booking.flight_number = flight_number;
    },
    changeMeetAndGreet(meet_and_greet) {
      this.bookingForm.booking.meet_and_greet = meet_and_greet;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-input--selection-controls__input {
  padding-right: 0px !important;
  margin-right: 0px !important;
}

.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}
</style>
